import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Category {
  TWL_ID: number;
  TWL_NAME: string;
  TWL_CREATEDBY: string;
  TWL_CREATEDTIME: string;
  TWL_UPDATEDBY: string | null;
  TWL_UPDATEDTIME: string | null;
}

export interface QuestionByRole {
  Id: number;
  QuestionText: string;
  Query: string;
  CategoryId: number;
  CreatedBy: string;
  CreatedDate: string; // ISO date string
  UpdatedDate: string | null; // ISO date string or null if no update
}
type UserGroup = 'WESTERN' | 'CAV' | 'OTHERGROUP';
@Injectable({
  providedIn: 'root'
})
export class insightsService {
  private baseUrl = 'https://devapi.axelone.app/api';
  private insightUrls: Record<UserGroup, string>={
    WESTERN: 'https://westernapi.axelone.app/api/xtract/getquery',
    CAV: '',
    OTHERGROUP: ''
  };

  constructor(private http: HttpClient) {}

  getCategories(): Observable<Category[]> {
    const url = `${this.baseUrl}/categories`;
    return this.http.get<Category[]>(url);
  }

  // Example method to get questions by role (userRole parameter)
  getQuestionsByRole(userRole: string): Observable<QuestionByRole[]> {
    const url = `${this.baseUrl}/questions/role/${userRole}`;
    return this.http.get<QuestionByRole[]>(url);
  }
  postQueryByUserGroup(userGroup: UserGroup, queryObject: { query: string }): Observable<any> {
    const url = this.insightUrls[userGroup];
    // no fallback necessary, since userGroup must be validated before passed here
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(url, queryObject, { headers });
  }
}
